import { Tooltip } from '@commenda/kakashi';
import { cn } from '@commenda/utils';

interface IDefinitionLabelProps {
  label: string;
  definition: string;
  /** Footnote number shown in exports instead of the tooltip. */
  footnote?: number;
  className?: string;
}

/** A term with a dotted underline whose definition appears on hover and as a footnote in exports. */
export const DefinitionLabel = ({
  label,
  definition,
  footnote,
  className,
}: IDefinitionLabelProps) => (
  <Tooltip content={definition} asChild>
    <span
      className={cn(
        'cursor-help border-b border-dotted border-border-primary text-text-secondary',
        className
      )}
    >
      {label}
      {footnote !== undefined && (
        <sup className="ml-xxs txt-extra-small-regular text-text-tertiary">
          {footnote}
        </sup>
      )}
    </span>
  </Tooltip>
);
